









































































import Component from "vue-class-component";
import { Watch, Mixins } from "vue-property-decorator";
import { EchartsChartConfigItemMixin } from "../../echarts-chart-config-item.mixin";
import { ChartOutputMetadataObserverMixin } from "../../../../chart-output-metadata-observer.mixin";
import { BaseTemplateType } from "../../../../../../shared/types/layout-workspace/components/template-selector/enums/template-type.enum";
import { getType, isArray, isNumber } from "../../../../../utils/get-type";
import { EventBus } from "../../../../../bus-events/event-bus";
import { CHART_DATA_UPDATED } from "../../../../../bus-events/chart-data-updated.event";
import { VuexModuleName } from "../../../../../../shared/types/vuex/enums/module-name.enum";
import { ChartTemplateDocument } from "@wave-charts/core/dist/src/storage/interfaces/chart-template.interface";
import { transformNumToLetter } from "../../../../../utils/transformNumToLetter";
import WorkspaceRendererMixin from "../../../../workspace-renderer.mixin";
import { WsRenderPart } from "../../../../../../shared/types/vuex/modules/workspace-renderer/enums/render-part.enum";

@Component({
  components: {
    WaveSelect: () => import("@/components/form/WaveSelect.vue"),
    Building: () => import("@/layout-home/Com.Building/index.vue"),
  },
})
export default class EchartsDataSelectorConfigItem extends Mixins(
  EchartsChartConfigItemMixin,
  ChartOutputMetadataObserverMixin,
  WorkspaceRendererMixin,
) {
  private activeTab = "short";
  private selectModels: Array<any> = [];
  private dataSelectInitFailed = false; // 当数据选择的初始值有空值， 设定为 true
  private metadataManual: any = { settings: [] };

  beforeCreate() {
    this.name = "echarts-data-selector";
    this.templateType = BaseTemplateType.CHART;
  }

  // Computed
  // ===================================================================
  /**
   * 获取 全部的 options
   */
  get options(): Array<{ label: string; value: number }> {
    if (
      !this.rawChartData ||
      this.rawChartData.length <= 0 ||
      this.rawChartData[0].length <= 0
    )
      return [];
    const options = this.rawChartData[0].map((name, index) => ({
      label: `${transformNumToLetter(index)}:${
        name || this.$t("echarts-config-data-selector-empty-header")
      }`,
      value: index,
    }));
    return options;
  }

  /**
   * 检查 每个 select 是否都已选择
   */
  get notReadyToCompleteDataSelect() {
    if (this.activeTab === "long") return true;
    if (!this.selectModels) return true;
    return this.selectModels.some((el) => !(isArray(el) ? el.length : el));
  }

  /**
   * 监听用户输入
   */
  @Watch("inputedRawChartData", { deep: true, immediate: false })
  onInputedDataChange() {
    this.getMetadataManually();
    // 这时候 select 的 options 不需要手动改变，但是选中状态需要重置
    this.selectModels.forEach((model, index) => {
      let newVal = null;
      if (isArray(model)) newVal = [];
      this.$set(this.selectModels, index, newVal);

      // 更新状态
      this.updateMetadata(`${this.name}.settings[${index}].value`, newVal);
    });
  }

  /**
   * 本来是在这里 watch selectedTemplateDoc 的，
   * 但是在 mixin 中有一个监听 来 同步 获取模板数据
   * 所以这里直接监听 selectedTemplateDoc 会拿不到数据
   * 所以 以 模板数据切换为 更换模板的依据
   */
  @Watch("templateRawChartData", { immediate: true })
  async watchTemplateChange(tplData, oldData) {
    if (!tplData) return;
    // 模板切换的时候， 需要重新触发数据选择
    await this.getMetadataManually();
    const metadata = this.metadataManual;
    let colIndexArr = [];
    let allFilled = true;
    metadata.settings.forEach(({ value, multiple }) => {
      // 判断是空数组 | null
      if ((isArray(value) && value.length === 0) || (value !== 0 && !value)) {
        allFilled = false;
        return;
      }
      colIndexArr = colIndexArr.concat(multiple ? value : [value]);
    });

    // 表单有空值
    if (!allFilled) {
      this.$q.notify({
        type: "danger",
        message: this.$t("echarts-config-data-selector-init-failed") as string,
      });
      this.dataSelectInitFailed = true;
      this.partRendered(WsRenderPart.CHART);
      return;
    }
    // 需要校验数据是否可以用来作图
    const maxIndex = colIndexArr.reduce((max, curr) => Math.max(max, curr), -1);
    let dataToProcess = oldData ? tplData : this.rawChartData;
    if (maxIndex >= this.options.length) {
      this.$q.notify({
        type: "danger",
        message: this.$t("echarts-config-data-selector-init-failed") as string,
      });
      dataToProcess = tplData;
    }
    this.getInitedSelectModels(maxIndex);

    this.chartData = this.generateData(dataToProcess, colIndexArr);
    EventBus.$emit(CHART_DATA_UPDATED, {
      data: this.chartData,
      templateChange: true,
    });
  }

  // Methods
  // ===================================================================
  confirmDataSelect() {
    const { rawChartData, selectModels } = this;
    let colIndexArr = [];
    selectModels.forEach((model) => {
      if (getType(model.value) === "[object Number]")
        colIndexArr.push(model.value);
      else model.forEach(({ value }) => colIndexArr.push(value));
    });
    const processedData = this.generateData(rawChartData, colIndexArr);
    this.chartData = processedData;
    /** 将新的数据选择列 存入 metadata */
    for (let i = 0; i < selectModels.length; i++) {
      const value =
        getType(selectModels[i]) === "[object Object]"
          ? selectModels[i].value
          : selectModels[i].map(({ value }) => value);
      this.updateMetadata(`${this.name}.settings[${i}].value`, value);
    }
    this.$q.notify({
      type: "success",
      message: this.$t(
        "echarts-config-data-selector-confirm-success",
      ) as string,
    });
    EventBus.$emit(CHART_DATA_UPDATED, {
      data: processedData,
      templateChange: this.dataSelectInitFailed,
    });
    this.dataSelectInitFailed = false;
  }

  /**
   * 拼接数据
   */
  generateData(srcData: any, indexArr: Array<number>) {
    return srcData.map((row) => {
      return indexArr.reduce((res, index) => {
        return res.concat([row[index]]);
      }, []);
    });
  }

  /**
   * 计算初始的 models
   */
  getInitedSelectModels(maxIndex: number): Array<any> {
    if (!this.metadataManual || this.options.length <= 0) return [];
    this.selectModels = this.metadataManual.settings.map(
      ({ value, multiple }) => {
        if (isNumber(value)) {
          value = [value];
        }
        if (multiple) {
          if (maxIndex >= this.options.length) {
            return (value || [0])
              .filter((v) => v < this.options.length)
              .map((v) => this.options[v]);
          } else {
            return (value || [0]).map((v) => this.options[v]);
          }
        } else {
          return this.options[value || 0];
        }
      },
    );
  }

  /**
   * （ * 超级加倍 ）
   *  这是由于一个奇怪的 bug 导致的 强行解决方案
   *  "⚠️每次新建的图表，切换模板后，数据选择会使用默认模板的数据选择，导致选择有误，稳定触发"
   *  测试： 新建的图表第一次打开（只有第一次会发生），在这个组件内拿到的 metadata 永远是旧的 metadata
   */
  async getMetadataManually() {
    return new Promise((resolve) => {
      setTimeout(() => {
        const { shareMode } = this;
        if (shareMode) {
          this.metadataManual = this.metadata;
          resolve(this.metadata);
          return;
        }
        const metadataManual =
          this.$stock.state[VuexModuleName.CHART_CONFIG].metadataRecords[
            this.name
          ];
        // const metadataFromMixin = this.metadata;
        this.metadataManual = metadataManual;
        // console.log({
        //   metadataFromMixin,
        //   metadataManual,
        // });
        resolve(metadataManual);
      }, 10);
    });
  }
}
